import {styled} from "@mui/material/styles"
import {Drawer as MUIDrawer} from "@mui/material"
import {breakpoints} from "@next/ux-fabric"

export const DrawerContainer = styled(MUIDrawer)`
    && > div:first-of-type {
        background: ${({theme}) => theme.uxfabric.components.backdrop.default.backgroundColor};
    }
    &&.drawer > div:nth-of-type(3) {
        width: calc(100% - 2.75rem);
        @media (max-width: ${breakpoints.values.md - 1}px) {
            background: #fff;
        }
    }
`
